import React from 'react';
import type { DefaultAutomationTemplateMetadata } from '@reach/shared-types/automation-template';
import { DialogHeader } from '../template-dialog-helpers';
import { TemplateList } from './TemplateList';

interface BaseSelectionProps {
  templates: DefaultAutomationTemplateMetadata[];
  onSelectTemplate: (templateName: string) => void;
  onClose: () => void;
}

export const BaseSelection: React.FC<BaseSelectionProps> = ({
  templates,
  onSelectTemplate,
  onClose,
}) => {
  return (
    <>
      <DialogHeader
        title="Create New Automation"
        subtitle="Choose a template to get started"
        onClose={onClose}
        showCloseButton
      />
      <TemplateList templates={templates} onSelectTemplate={onSelectTemplate} />
    </>
  );
};
